export { default as default } from './eventProcessor';
